/**
 * Notification Module called Heinz
 * Why Heinz? Heinz (Prueller) "shouts"/makes annoucements during sports events, therefore…
 *
 * @module Heinz
 * @author EN GARDE - Marcel Seelig
 * @version 1.1
 * @requires jQuery
 * @requires lodash
 * @requires JsHelper
 * @requires StringTemplate
 *
 * change log:
 * v1.1 cleanup of initial release
 * v1.0 initial release
 *
 * @todo build message queue to push to/read from
 *
 * ---------------------------------------------------------------------
 * Example
 * ---------------------------------------------------------------------
 *
 * EN.Heinz.create({
 * 	content: 'This is <strong>nuts</strong>, {{name}}!',
 * 	icon: 'symbol', // select any from icon system
 * 	behavior: 'auto', // auto, dismissable
 * 	type: 'default', // default, important, error
 * 	namespace: 'namespace-group',
 * }, {
 * 	name: 'Heinz',
 * });
 *
 * ---------------------------------------------------------------------
 * HTML
 * ---------------------------------------------------------------------
 *
 * <div class="en-heinz">
 *	<div class="en-heinz__item en-heinz__item--dismissable en-heinz__item--highlight en-wysiwyg" id="en-heinz-unique-id" data-en-namespace="namespace-group" data-en-icon="symbol">
 *		This is <strong>nuts</strong>, Heinz!
 *	</div>
 * </div>
 *
 */

var EN = EN || {};

EN.Heinz = (function ($, _) {
	'use strict';

	var options = {
		classNames: {
			container: 'en-heinz', // container where notifications go, needs to exist beforehand
			element: 'en-heinz__item', // single notificattion
			dismissable: 'en-heinz__item--dismissable', // notification type: dismissable
			important: 'en-heinz__item--highlight', // notification style: important
			error: 'en-heinz__item--error', // notification style: error
			visible: 'en-is-visible',
		},
		attributes: {
			namespace: 'data-en-namespace',
		},
		selectors: {},
		timings: {
			hold: 5000,
			remove: 750,
		},
	};

	var NOTIFICATION_BEHAVIOR_AUTO = 'auto';
	var NOTIFICATION_BEHAVIOR_DISMISSABLE = 'dismissable';

	var NOTIFICATION_TYPE_DEFAULT = 'default';
	var NOTIFICATION_TYPE_IMPORTANT = 'important';
	var NOTIFICATION_TYPE_ERROR = 'error';

	var $container;
	var isInitialized = false;

	/**
	 * Init
	 * @param  {object} settings - overrides options
	 * @return {boolean} - init success
	 */
	var init = function (settings) {

		if (!EN.JsHelper) throw new Error('Heinz shouts: I‘m missing EN.JsHelper!');
		if (!EN.StringTemplate) throw new Error('Heinz shouts: I‘m missing EN.StringTemplate!');

		options = _.defaultsDeep(settings, options);

		options.selectors.container = EN.JsHelper.classNamesToSelector(options.classNames.container);
		$container = $(options.selectors.container);
		// if (!$container) return false;

		options.selectors.element = EN.JsHelper.classNamesToSelector(options.classNames.element);
		options.selectors.dismissable = EN.JsHelper.classNamesToSelector(options.classNames.dismissable);
		options.selectors.important = EN.JsHelper.classNamesToSelector(options.classNames.important);

		$(document).on('click', options.selectors.element , function(e) {
			if (e.currentTarget === e.target) {
				fadeOut($(e.currentTarget));
			}
		});

		isInitialized = true;
		return true;
	};

	/**
	 * Fade out notification
	 * @param {jQuery} $notification - notification jquery object
	 */
	var fadeOut = function($notification) {
		if (!isInitialized || typeof $notification === 'undefined') return false;

		// fade out message
		$notification.removeClass(options.classNames.visible);

		// remove message
		setTimeout(function() {
			$notification.remove();
		}, options.timings.remove);

	};

	/**
	 * Create a notification
	 * @param  {object} message - message object
	 * @param  {array} templateVars - template vars
	 * @return {boolean} - success
	 */
	var create = function(message, templateVars) {
		if (!isInitialized || typeof message !== 'object') return false;
		templateVars = (typeof templateVars === 'object') ? templateVars : false;

		var guid = 'en-heinz-' + EN.JsHelper.createUniqueId();
		var namespace = message.namespace || false;
		var text = message.content;

		if (templateVars !== false) {
			var textTemplate = new EN.StringTemplate();
			textTemplate.setVars(templateVars);
			text = textTemplate.getParsedTemplateString(text);
		}

		var $message = $('<div class="' + options.classNames.element + '">' + text + '</div>');
		$message.attr('id', guid);
		if (namespace) $message.attr(options.attributes.namespace, namespace);
		if (!!message.icon) {
			$message.addClass('en-icon');
			$message.attr('data-en-icon', message.icon);
		}
		if (message.behavior === NOTIFICATION_BEHAVIOR_DISMISSABLE) {
			$message.addClass(options.classNames.dismissable);
		}
		if (message.type !== NOTIFICATION_TYPE_DEFAULT) {
			$message.addClass(options.classNames[message.type]);
		}

		// same namespace
		var $namespace = $('[' + options.attributes.namespace + '="' + namespace + '"]');

		// append later
		$container.append($message);
		var $notification = $('#'+guid);

		// remove same namespace first
		$namespace.each(function() {
			remove('#' + $(this).attr('id'));
		});

		// fade in message
		setTimeout(function() {
			$notification.addClass(options.classNames.visible);

			// if automatic behavior
			if (message.behavior === NOTIFICATION_BEHAVIOR_AUTO) {
				setTimeout(function() {
					fadeOut($notification);
				}, options.timings.hold);
			}

		}, 1);

		return true;

	};

	/**
	 * Remove a notification by its unique id
	 * @param {string} id unique id to select notification
	 */
	var remove = function(id) {
		if (!isInitialized) return false;
		var $notification = $(id);
		fadeOut($notification);
		return true;
	};

	// exports
	return {
		init: init,
		create: create,
		remove: remove,
	};

}(jQuery, _));
